/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Wspolny zakres: ostatni wybor wygrywa, wyniki i wnioski maja te same dane. */
(function () {
    'use strict';
    function enText(pl, en) { return /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : pl; }
    var root = document.querySelector('[data-analiza-strona]');
    var box = document.querySelector('[data-zakres]'), api = window.PEWNIAKI_ANALIZA;
    var state = new URL(location.href).searchParams;
    function linki(params) {
        if (!root) return;
        root.querySelectorAll('a[href]').forEach(function (a) {
            // Panele SSR i przełącznik raportu mają własny zakres. Nie nadpisuj ich.
            if (a.closest('[data-ra-panel], [data-ryt-charts], [data-ol-okna], [data-raport-fb], [data-pilot-raport-lotto]')) return;
            var href = a.getAttribute('href');
            if (!href || href.charAt(0) === '#') return;
            var u = new URL(href, location.href);
            if (u.origin !== location.origin || !/\/(?:statystyki|statistics)(?:\/|$)/.test(u.pathname)) return;
            ['okno','od','do','n'].forEach(function (k) { u.searchParams.delete(k); });
            ['okno','od','do'].forEach(function (k) {
                var v=params.get(k);
                if (v && /^(?:all|\d{1,4})$/.test(v)) u.searchParams.set(k,v);
            });
            a.setAttribute('href',u.pathname+u.search+u.hash);
        });
    }
    linki(state);
    if (!box || !api || !api.plik || typeof api.render !== 'function') return;
    var sel=box.querySelector('[data-zakres-okno]'), od=box.querySelector('[data-zakres-od]'), doR=box.querySelector('[data-zakres-do]');
    var nEl=box.querySelector('[data-zakres-n]'), powodEl=box.querySelector('[data-zakres-powod]'), zmianaEl=box.querySelector('[data-zakres-zmiana]');
    var dane, cache={}, cacheOkien={}, seq=0;
    if (!sel) return;
    var customForm=box.querySelector('[data-zakres-wlasne]');
    if(customForm) customForm.addEventListener('submit',function(event){
        event.preventDefault();if(!customForm.reportValidity())return;
        var u=new URL(location.href);['od','do','n','okno_wlasne','raport_data','raport_czas','raport_metoda'].forEach(function(k){u.searchParams.delete(k);});
        u.searchParams.set('okno',customForm.elements.okno.value);location.assign(u.href);
    });
    var przyciski=box.querySelector('[data-zakres-przyciski]');
    function zaznaczZakres() {
        if(customForm) customForm.elements.okno.value=/^\d+$/.test(sel.value)?sel.value:'';
        if (!przyciski) return;
        przyciski.querySelectorAll('[data-zakres-przycisk]').forEach(function (button) {
            var active=button.dataset.zakresPrzycisk===sel.value;
            button.hidden=active;
            button.setAttribute('aria-pressed',active?'true':'false');
            button.classList.toggle('jest-aktywny',active);
        });
    }
    if (przyciski) przyciski.addEventListener('click',function (event) {
        var button=event.target.closest('[data-zakres-przycisk]');
        if (!button || !przyciski.contains(button) || sel.disabled) return;
        sel.value=button.dataset.zakresPrzycisk;
        sel.dispatchEvent(new Event('change',{bubbles:true}));
    });
    function komunikat(text) { if (powodEl) { powodEl.hidden=!text; powodEl.textContent=text||''; } }
    function pokaz(o,key,zakres) {
        if (nEl) {
            var pokazN = !!(o && o.losowan != null && String(o.losowan) !== String(key));
            nEl.hidden = !pokazN;
            nEl.textContent = pokazN ? jst("pages_analiza_js.6c3b1ad36491")+o.losowan : '';
        }
        api.render(o,key,dane,zakres);
        window.PewniakiAnalizaZakres = { game: root && root.dataset.gra, key: key, n: o && o.losowan, dates: o && o.zakres_dat, years: zakres && { od: zakres.od, do: zakres.do } };
        document.dispatchEvent(new CustomEvent('pewniaki:analiza-zakres', { detail: window.PewniakiAnalizaZakres }));
        var wrap=document.querySelector('[data-analiza-wnioski]'), list=wrap && wrap.querySelector('.wniosek__lista');
        if (!list) return;
        var punkty=typeof api.wnioski==='function' ? api.wnioski(o,key,dane,zakres) : [o ? jst("pages_analiza_js.cbf281fa5bd6")+o.losowan+jst("pages_analiza_js.9f1d24d80634") : jst("pages_analiza_js.0cfaa0222820")];
        list.replaceChildren();
        (punkty||[]).forEach(function (t) {
            var li=document.createElement('li'), span=document.createElement('span');
            li.className='wniosek__punkt'; span.className='wniosek__zdanie'; span.textContent=String(t);
            li.appendChild(span); list.appendChild(li);
        });
    }
    function adres(params) {
        var u=new URL(location.href);
        ['okno','od','do','n'].forEach(function(k){u.searchParams.delete(k);});
        Object.keys(params).forEach(function(k){u.searchParams.set(k,params[k]);});
        history.replaceState(null,'',u.pathname+u.search+u.hash); linki(u.searchParams);
    }
    function brak(o) {
        if(o && o.powod==='ponizej_progu') return jst("pages_analiza_js.0593ca6b4e92");
        if(o && o.powod==='za_krotka_historia') return jst("pages_analiza_js.c27a251b483b")+o.brakuje+jst("pages_analiza_js.9f1d24d80634");
        return jst("pages_analiza_js.0cfaa0222820");
    }
    function pobierzOkno(key) {
        if (!api.oknoPlik) return Promise.resolve(dane.okna[key]);
        if (cacheOkien[key]) return Promise.resolve(cacheOkien[key]);
        return fetch(api.oknoPlik+encodeURIComponent(key)+'.json?v='+encodeURIComponent(api.wersja||''))
            .then(function(r){if(!r.ok)throw new Error('HTTP');return r.json();})
            .then(function(o){if(!o || typeof o!=='object' || !Object.prototype.hasOwnProperty.call(o,'powod'))throw new Error('format');cacheOkien[key]=o;return o;})
            .catch(function(){
                return fetch(api.plik+'?v='+encodeURIComponent(api.wersja||''))
                    .then(function(r){if(!r.ok)throw new Error('HTTP');return r.json();})
                    .then(function(full){if(!full || !full.okna)throw new Error('format');dane=full;api.oknoPlik=null;return full.okna[key];});
            });
    }
    function rok(r) {
        if(cache[r]) return Promise.resolve(cache[r]);
        return fetch(api.lata+r+'.json?v='+encodeURIComponent(api.wersja||''))
            .then(function(res){if(!res.ok) throw new Error('HTTP'); return res.json();})
            .then(function(d){cache[r]=d; return d;});
    }
    function przelacz() {
        if(!dane) return;
        var id=++seq,key=sel.value;
        zaznaczZakres();
        box.querySelectorAll('.okno-lata').forEach(function(e){e.hidden=key!=='lata';}); komunikat('');
        if(key!=='lata') {
            var o=dane.okna && dane.okna[key]; adres({okno:key});
            if(!o || o.powod) {pokaz(null,key,null); komunikat(brak(o)); return;}
            if(api.oknoPlik){
                komunikat(jst("pages_analiza_js.7969da8d94d9"));
                pobierzOkno(key).then(function(pelne){
                    if(id!==seq)return;
                    if(!pelne || pelne.powod){pokaz(null,key,null);komunikat(brak(pelne));return;}
                    pokaz(pelne,key,null);komunikat('');
                }).catch(function(){if(id!==seq)return;pokaz(null,key,null);komunikat(jst("pages_analiza_js.11c4d68a898c"));});
                return;
            }
            pokaz(o,key,null);
            if(o.testy_powod) komunikat(jst("pages_analiza_js.0761059aa60d"));
            return;
        }
        if(!od || !doR || !api.lata || typeof api.sumujLata!=='function') {pokaz(null,key,null); komunikat(jst("pages_analiza_js.3c09bb948762")); return;}
        if(+od.value>+doR.value) doR.value=od.value;
        var a=+od.value,b=+doR.value,lata=Array.from(od.options,function(o){return +o.value;}).filter(function(r){return r>=a && r<=b;});
        adres({od:a,do:b}); pokaz(null,key,null); komunikat(jst("pages_analiza_js.7969da8d94d9"));
        Promise.all(lata.map(rok)).then(function(roczniki){
            if(id!==seq) return;
            var o=api.sumujLata(roczniki); if(!o) throw new Error('brak');
            pokaz(o,key,{od:a,do:b,roczniki:roczniki}); komunikat('');
        }).catch(function(){if(id!==seq)return; pokaz(null,key,null); komunikat(jst("pages_analiza_js.11c4d68a898c"));});
    }
    function ma(s,v){return s && Array.from(s.options).some(function(o){return o.value===v;});}
    function domyslny(){
        // Okno wybrane po stronie serwera (?okno= po walidacji w engine.php, inaczej 50)
        // — SSR i JS maja startowac z tego samego zakresu (17.09.2026, etap B pkt 7).
        var ssr=box.dataset.domyslne||'50';
        if(ma(sel,ssr) && dane.okna[ssr] && !dane.okna[ssr].powod) return ssr;
        if(ma(sel,'50') && dane.okna['50'] && !dane.okna['50'].powod) return '50';
        return Array.from(sel.options).map(function(o){return o.value;}).find(function(v){return dane.okna[v] && !dane.okna[v].powod;}) || sel.value;
    }
    sel.addEventListener('change',przelacz); if(od) od.addEventListener('change',przelacz); if(doR) doR.addEventListener('change',przelacz);
    sel.disabled=true;
    fetch((api.plikStart||api.plik)+'?v='+encodeURIComponent(api.wersja||''))
        .then(function(r){if(!r.ok)throw new Error('HTTP');return r.json();})
        .catch(function(){
            api.oknoPlik=null;
            return fetch(api.plik+'?v='+encodeURIComponent(api.wersja||''))
                .then(function(r){if(!r.ok)throw new Error('HTTP');return r.json();});
        })
        .then(function(d){
            dane=d; if(!d || !d.okna)throw new Error('format');
            var embedded=document.getElementById('analiza-wlasne-okno');
            if(embedded){var extra=JSON.parse(embedded.textContent);d.okna[extra.key]=extra.data;cacheOkien[extra.key]=extra.data;if(!ma(sel,extra.key))sel.add(new Option(extra.key,extra.key));}
            sel.value=domyslny();
            var requested=state.has('okno')||state.has('od')||state.has('do'),restored=false;
            if(state.has('od') && state.has('do') && ma(sel,'lata') && ma(od,state.get('od')) && ma(doR,state.get('do')) && +state.get('od')<=+state.get('do')){
                sel.value='lata';od.value=state.get('od');doR.value=state.get('do');restored=true;
            }else if(!state.has('od') && !state.has('do') && ma(sel,state.get('okno'))){
                var o=d.okna[state.get('okno')]; if(o && !o.powod){sel.value=state.get('okno');restored=true;}
            }
            if(requested && !restored && zmianaEl){zmianaEl.hidden=false;zmianaEl.textContent=jst("pages_analiza_js.d99742ea3c2d")+sel.options[sel.selectedIndex].textContent+'.';}
            sel.disabled=false;
            if (przyciski) {
                przyciski.hidden=false;
                var selectWrap=box.querySelector('[data-zakres-select]');
                if (selectWrap) selectWrap.hidden=true;
            }
            przelacz();
        }).catch(function(){
            sel.disabled=true;
            // strony bez onError zachowuja dotychczasowe zachowanie
            if(typeof api.onError==='function'){try{api.onError();}catch(e){}}
            komunikat(jst("pages_analiza_js.f9a513028289"));
        });
})();
